import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormMaskedTextBox, FormTextArea, FormUpload } from "@mikros/shared-ui";
import { useIntl } from "react-intl";

export function CreateStaticList() {
  const intl = useIntl();
  const validators = {
    cname: (value: string) =>
      !value
        ? intl.formatMessage({ id: "users.createStaticList.enterNameOfCohort" })
        : "",
  };
  async function signIn() {}

  return (
    <div>
      <div>
        <Form
          onSubmit={signIn}
          render={(formRenderProps) => (
            <FormElement>
              <Field
                name={"cname"}
                id={"cname"}
                label={intl.formatMessage({
                  id: "users.createStaticList.giveNameToCohort",
                })}
                component={FormMaskedTextBox}
                validator={validators.cname}
                className="bg-white w-96"
              />

              <Field
                name={"cdesc"}
                id={"cdesc"}
                label={intl.formatMessage({
                  id: "users.createStaticList.describeCohort",
                })}
                component={FormTextArea}
                className="bg-white w-96"
              />

              <Field
                name={"ufile"}
                id={"ufile"}
                label={intl.formatMessage({
                  id: "users.createStaticList.uploadFile",
                })}
                component={FormUpload}
                className="bg-white w-96"
              />
            </FormElement>
          )}
        />
      </div>
    </div>
  );
}
